import { render, staticRenderFns } from "./CommonPopup.vue?vue&type=template&id=60608323&scoped=true"
import script from "./CommonPopup.vue?vue&type=script&lang=js"
export * from "./CommonPopup.vue?vue&type=script&lang=js"
import style0 from "./CommonPopup.vue?vue&type=style&index=0&id=60608323&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60608323",
  null
  
)

export default component.exports